<template>
  <panel-layout
    id="customers-panel"
    :loading="!!(customers && customers.loading) || loading || false"
    :heading="$t('general.customers')"
    :show-footer="false"
  >
    <template #heading>
      <div class="flex items-center space-x-3">
        <h2 class="focus:outline-none text-xl tracking-tight font-semibold text-gray-800 items-center">
          {{ $t('general.customers') }}
        </h2>
      </div>
    </template>

    <template #actions-right>
      <template v-if="$features.get('campaigns') && customers.length !== 0">
        <o-tooltip :text="$t('pages.customer.list.createMarketingCampaign')">
          <o-panel-link
            tag="o-button"
            flat
            :props="{ customers: ids }"
            path="/marketing/campaigns/edit"
            class="hidden md:inline-flex"
            icon="marketing"
          />
        </o-tooltip>
      </template>
    </template>

    <div class="h-full min-h-0 flex flex-col overflow-hidden text-sm text-gray-800">
      <o-table
        v-model:data="customers"
        :headers="[
          $t('general.customer'),
          $t('general.email'),
          $t('general.phone'),
          $t('general.marketingConsent'),
          $t('general.actions')
        ]"
        scroll
        class="flex-shrink flex-grow min-h-0"
      >
        <template #row="props">
          <td :class="props.tdClass">
            {{ props.row ? props.row.displayName : '-' }} ({{ props.row.idCustomer }})
          </td>
          <td :class="props.tdClass">
            {{ props.row.email || '-' }}
          </td>
          <td :class="props.tdClass">
            {{ props.row.phone || '-' }}
          </td>
          <td :class="props.tdClass">
            <div class="flex items-center flex-wrap">
              <o-chip v-if="props.row.marketingConsentAccepted != CustomerMarketingConsent.accepted" variant="danger" flat size="sm" class="mr-1 mb-1">
                {{ $t('general.colonSeparator', { label1: $t('pages.customer.list.marketingConsent'), label2: $t(CustomerMarketingConsentLabels[props.row.marketingConsentAccepted]) }) }}
              </o-chip>

              <o-chip v-if="props.row.massEmailUnsubscribed != CustomerMassEmail.subscribed" variant="danger" flat size="sm" class="mr-1 mb-1">
                {{ $t('general.colonSeparator', { label1: $t('pages.customer.list.massEmail'), label2: $t(CustomerMassEmailLabels[props.row.massEmailUnsubscribed]) }) }}
              </o-chip>

              <o-chip v-if="props.row.massSMSUnsubscribed != CustomerMassSMS.subscribed" variant="danger" flat size="sm" class="mr-1 mb-1">
                {{ $t('general.colonSeparator', { label1: $t('pages.customer.list.massSMS'), label2: $t(CustomerMassSMSLabels[props.row.massSMSUnsubscribed]) }) }}
              </o-chip>
            </div>
          </td>
          <td :class="props.tdClass">
            <div class="flex items-center space-x-2">
              <o-panel-link :path="`/customer/panel?id=${props.row.idCustomer}`" slim flat icon="view" tag="o-button" />
              <o-panel-link :path="`/customer/edit?id=${props.row.idCustomer}`" slim flat icon="edit" tag="o-button" />
            </div>
          </td>
        </template>
      </o-table>
    </div>
  </panel-layout>
</template>
<script setup lang="ts">
import { utils, writeFileXLSX } from 'xlsx'

// @ts-ignore
import PanelLayout from '@/components/panel/PanelLayout.vue'

// @ts-ignore
import {
  OTable,
} from '@/components/elements'

import {
  TablePager,
} from '@/_api/lib/pager'

import { CustomerMarketingConsent, CustomerMarketingConsentLabels, CustomerMassEmail, CustomerMassEmailLabels, CustomerMassSMS, CustomerMassSMSLabels } from '@/_api/models/customer'

import { usePanel } from '~/composables/usePanel'

const props = defineProps<{ ids?: string }>()

const { $api, $notification, $features } = useNuxtApp()

const panel = usePanel()

const ids = props.ids?.split(',')

const customers = ref<any>(new TablePager((page: number) => $api.customer.ids(ids, page), 20))
const loading = ref(false)

const fetchCustomers = async () => {
  try {
    await customers.value.load()
  } catch (e: any) {
    console.log(e)
    $notification.error({ errors: e?.errors })
  }
}

onMounted(() => {
  fetchCustomers()
})
</script>
